import style from './style.css';

const PostTxnContainer = () => {
  return (
    <div className={style.postTxnCardContainer}>
      <div className={style.postTxnTextContainer}>
        <img
          className={style.logoImage}
          src='https://iccdn.in/bic/icons/approved-logo.svg'
          alt='cart-logo'
        />
        <div className={style.textContainer}>
          <div className={style.cardlessEmiText}>
            Congratulations! <br />
          </div>{' '}
          <span className={style.subText}>
            Your recent transaction was successful
          </span>
        </div>
      </div>
    </div>
  );
};

export default PostTxnContainer;



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/preApprovedCard/postTxnContainer/index.js